import axios from 'axios';
import { Message } from 'element-ui';
import { getCookie, setCookie, delCookie } from "../utils/util";
import { reqToken } from '../api/userMG'
// import {
//   Loading
// } from 'element-ui';

//设置axios请求地址
axios.defaults.baseURL = process.env.VUE_APP_URL
//设置请求超时
axios.defaults.timeout = 1000000;
let loading;

//请求拦截器
axios.interceptors.request.use(res => {
    if (getCookie('logintoken')) {
        res.headers.Authorization = `Bearer ${getCookie('logintoken')}`;
        console.log(res.headers.Authorization)
        if (isRefreshTokenExpired()) {
            if (!window.isRefreshing) { // /*判断是否正在刷新*/
                window.isRefreshing = true;
                getRefreshToken().then(item => {
                    res.headers.Authorization = `Bearer ${item.data.accessToken}`;
                    setCookie("logintoken", item.data.accessToken, 1);
                    window.isRefreshing = false;
                })
            }
        }
    }

    //   loading = Loading.service({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });

    return Promise.resolve(res);
}, function (err) {
    return Promise.reject(err);
});

//响应拦截器
axios.interceptors.response.use(
    function (response) {
        // 对响应数据做点什么
        let data = response.data;
        let code = data.code
        if (code) {
            // 业务需求
            if (data.code !== 200 && data.code !== 401 && data.code !== 403) {
                Message.error(data.msg);
                return Promise.reject(data);
            } else if (data.code == 401) {
                // Message.error('请刷新页面或重新登录');
                // 请求成功的处理逻辑
                delCookie("logintoken");
                window.location.reload();
                return Promise.reject(data);
            } else if (data.code == 403) {
                Message.error(data.msg);
                return Promise.reject(data);
            } else {
                return Promise.resolve(response.data);
            }
        } else {
            return Promise.resolve(response);
        }

    },
    function (error) {
        // 对响应错误做点什么
        Message.error('响应错误');
        return Promise.reject(error)
    }
);

function isRefreshTokenExpired() {
    let oData = sessionStorage.getItem('loginTime'); // 这是在登陆时候保存的时间戳
    let nDta = new Date().getTime();
    let stamp = nDta - oData;
    let minutes = parseInt((stamp % (1000 * 60 * 60)) / (1000 * 60));
    if (minutes >= 60) {
        sessionStorage.setItem('loginTime', nDta)
        return true;
    } else {
        return false;
    }
}

async function getRefreshToken() { // 刷新token 注意这里用到的service
    const res = await reqToken();
    return Promise.resolve(res);
}
// export const post = (url, params) => {
//   return axios.post(`${url}`, params, {
//     headers: {
//       "Content-Type": "multipart/form-data"
//     }
//   }).then(res => res.data);
// }

export const put = (url, params) => {
    return axios.put(`${url}`, params).then(res => res);
}

export const post = (url, params) => {
    return axios.post(`${url}`, params).then(res => res);
}
export const get = (url, params) => {
    return axios.get(`${url}`, {
        params: params
    }).then(res => res)
}

export const del = (url, params) => {
    return axios.delete(`${url}`, params).then(res => res);
}


// WEBPACK FOOTER //
// ./src/api/axioshHttp.js